import type { FaireProductEntity } from "../../entity_types/product";

export const p_6f4kj2gty6: FaireProductEntity = {
  token: "p_6f4kj2gty6",
  type: "product",
  name: "Book Slut Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a577912c298e926aa61f88a938f4931613a358446433373fdefa8a413cb7e588.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0cb1262f4e837bec8ef27038ae051461dbd4fe979e8ac52e60922478aa7cca4.jpeg",
    "https://cdn.faire.com/fastly/34b07e99e9ba45a7aa20debed8b5154eb0a410f8b09c74705d1006009da8063a.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/77d100b99e2303d8d181ff0315a8aa0ddb0cbb9132a24b8da30b6da09df5831f.jpeg",
    "https://cdn.faire.com/fastly/07d9e6aa1247007f9567716bebeecd75232e76cbe3a1d41629cfe341987c412b.jpeg",
    "https://cdn.faire.com/fastly/ae8b36a62207c74c308577eba767f4f6336e134bc3045c773deaa0a800ea9aad.jpeg",
    "https://cdn.faire.com/fastly/ae80163cf9580d739a50614e826a17b1d59994928ad47b7333034872129d4d27.jpeg",
    "https://cdn.faire.com/fastly/31bc78d5d3f08ecf4ae2bff744fa202dad36cbb586d8210f79e95623f8232187.jpeg"
  ],
  priceDollars: 9.6,
  description: "For book sluts whose spinal alignment depends entirely on how good the plot gets. 📖\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:26.921Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
